import { INamedFilterFieldsFragment } from '../../../apollo/graphqlSchema';
import { getFilterEventProperties } from './utils';
import { IAnalyticsEventFilter } from './types';

export const filterSaved = (
  namedFilter: INamedFilterFieldsFragment,
): IAnalyticsEventFilter => ({
  eventName: 'Filter Saved',
  ...getFilterEventProperties(namedFilter),
});
